export default __webpack_public_path__ + "static/media/login-bg.bf9d0909.svg";